"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.HomePage = void 0;
var doshx_controls_web_1 = require("doshx_controls_web");
var react_1 = __importDefault(require("react"));
var react_router_dom_1 = require("react-router-dom");
var choice_card_1 = require("./components/choice_card");
var home_baner_1 = require("./components/home_baner");
var services_1 = require("./components/services");
var hot_deals_1 = require("../../components/hot_deals");
var recommended_deals_1 = require("../../components/recommended_deals");
var categories_1 = require("./components/categories");
var themes_1 = require("./components/themes");
var blog_1 = require("./components/blog");
var virtual_care_1 = require("./components/virtual_care");
var home_sliders_1 = require("./components/home_sliders");
var HomePage = function () {
    var navigate = (0, react_router_dom_1.useNavigate)();
    return (react_1.default.createElement("div", { className: "" },
        react_1.default.createElement(doshx_controls_web_1.ScreenContainerControl, { className: "flex flex-col gap-8" },
            react_1.default.createElement("div", { className: "flex md:flex-row w-full gap-4" },
                react_1.default.createElement("div", { className: "grid grid-cols-1 md:grid-cols-3 gap-4 w-full" },
                    react_1.default.createElement("div", { className: "md:col-span-2" },
                        react_1.default.createElement(home_sliders_1.HomeSliders, null)),
                    react_1.default.createElement("div", { className: "md:col-span-1" },
                        react_1.default.createElement(home_baner_1.HomeBanner, null)))),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(services_1.ServicesComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(choice_card_1.ChoiceCardComponent, { onButtonClick: function () {
                        navigate("/choice-card");
                    } })),
            react_1.default.createElement("div", { className: "pb-5" },
                react_1.default.createElement(categories_1.CategoriesComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(hot_deals_1.HotDealsComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(recommended_deals_1.RecommendedDealsComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(themes_1.ThemesComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(virtual_care_1.VirtualCareComponent, null)),
            react_1.default.createElement("div", { className: "" },
                react_1.default.createElement(blog_1.BlogComponent, null)))));
};
exports.HomePage = HomePage;
